import { render, staticRenderFns } from "./MultiselectOwners.vue?vue&type=template&id=1879f8ee&"
import script from "./MultiselectOwners.vue?vue&type=script&lang=js&"
export * from "./MultiselectOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports